import parse from "html-react-parser"
import styles from "./header.module.scss"

interface Props {
  onBackClick?: () => void
  // The Figma only puts the logo + plan badge on the initial step's header.
  tierName?: string
}

import chevronLeftBlack from "images/layout/chevron-left-black.svg?raw"
import iftttLogo from "images/logo-ifttt.svg?raw"
import proBadge from "images/plan-badges/pro.svg?raw"
import proPlusBadge from "images/plan-badges/pro_plus.svg?raw"

const Header = ({ onBackClick, tierName }: Props) => {
  return (
    <header className={styles.cancelling_billing}>
      {onBackClick && (
        <button
          type="submit"
          className="button-tertiary button-outlined button-with-icon only-icon-on-mobile"
          aria-label="Back button"
          onClick={onBackClick}
        >
          <span className="button-icon">{parse(chevronLeftBlack)}</span>
          <span className="hide-on-xs">Back</span>
        </button>
      )}
      {tierName && (
        <div className={styles.plan_badges} role="img" aria-label={`IFTTT ${tierName}`}>
          {parse(iftttLogo)}
          {parse(tierName === "Pro+" ? proPlusBadge : proBadge)}
        </div>
      )}
    </header>
  )
}

export default Header
